import { updateApprovedStatusBooking } from './updateApprovedStatusBooking'
import { updateAwaitingPaymentStatusBooking } from './updateAwaitingPaymentStatusBooking'
import { updateCancelStatusBooking } from './updateCancelStatusBooking'

export {
    updateApprovedStatusBooking,
    updateAwaitingPaymentStatusBooking,
    updateCancelStatusBooking
}